import React, { useEffect, useMemo, useState } from "react";
import { Redirect, Switch } from "react-router-dom";
import cogoToast from "cogo-toast";

import { useDownloadTransactionsReportMutation, useGetBillingHistoryQuery } from "../../../../../redux/apiSlice";
import { SubHeader } from "../../../Common/layout/SubHeader";
import { ContentRoute } from "../../../../../_metronic/layout";
import { Card, CardBody, CardHeader, CardHeaderToolbar } from "../../../../../_metronic/_partials/controls";
import DynamicSimpleTable from "../../../../util/DynamicSimpleReactTable";
import { errorMessage, formatActivity, formatAmount, formatDate, formatLongDate, formatStatus, formatUsername, truncateString, ucFirst } from "../../../../util/Helpers";
import { Permissions, PermissionType } from "../../../../util/Permissions";
import { Permission } from "../../../Common/layout/Permission";
import ProcessBillingsModal from "../modals/ProcessBillingsModal";


export const BillingDetails = ({
    match: {
        params: {

            billingId,
            userGroup
        }
    }

}) => {
    const { data: billings } = useGetBillingHistoryQuery()


    const billing = useMemo(() => {
        return billings?.data?.find((billingHistory) => billingHistory.autoId === billingId)
    }, [billings, billingId])

    const [
        downloadTransactionsReport,
        {
            isLoading: isLoadingReport,
            isSuccess: isReportGenerating,
            error: errorReport,
        }
    ] = useDownloadTransactionsReportMutation(userGroup)

    useEffect(() => {
        if (isReportGenerating) {
            cogoToast.success(`Billing report export in progress. The resulting file will be sent to your mail.`);
        }
    }, [isReportGenerating])

    /* Maintenance Fee Modal State Management */
    const [processBillingsModal, setProcessBillingsModal] = useState({ showProcessBillingModal: false, details: null });

    /* Modal show/hide Toggle */
    const toggleModal = modal => _ => {
        setProcessBillingsModal({ ...processBillingsModal, [modal]: !processBillingsModal[modal] })
    }



    return <>
        <div className="d-flex flex-column h-100">
            <SubHeader>
                <SubHeader.Nav>
                    <SubHeader.NavItem label={"Transaction History"} to={`/maintenance/:userGroup/accounts/billing-history/${billingId}/transactions`} />
                </SubHeader.Nav>
            </SubHeader>

            <Switch>
                <Redirect exact={true} from="/maintenance/:userGroup/accounts/billing-history/:billingId/" to={`/maintenance/:userGroup/accounts/billing-history/${billingId}/transactions`} />

                <ContentRoute path="/maintenance/:userGroup/accounts/billing-history/:billingId/transactions" exact permission={Permissions.MAINTENANCE_FEE}>
                    <div className="py-4 px-6 h-100">
                        <Card>
                            <CardHeader>
                                <div className="card-title py-5">
                                    <h3 className="card-label">
                                        <span className="d-block text-dark h3 mb-1 font-weight-bolder">{formatLongDate(billing?.created)}</span>
                                    </h3>
                                </div>
                                <Permission permission={Permissions.REPORTS} permissionType={PermissionType.CREATE}>
                                    <CardHeaderToolbar>
                                        <button
                                            type="button"
                                            className={`btn btn-dark`}
                                            onClick={toggleModal("showProcessBillingModal")}
                                        >
                                            Process Billing
                                        </button>

                                        <div style={{ marginLeft: '10px' }}></div>

                                        <button
                                            type="button"
                                            className="btn btn-primary"
                                            disabled={isLoadingReport}
                                            onClick={() => {
                                                downloadTransactionsReport({
                                                    format: "csv",
                                                    userGroup: "trove",
                                                    partner: "dw",
                                                    liveData: "true",
                                                    refId: `${billingId}`

                                                });
                                            }}
                                        >
                                            Export CSV
                                        </button>
                                    </CardHeaderToolbar>
                                </Permission>
                            </CardHeader>
                            <CardBody>
                                <DynamicSimpleTable
                                    key={`${billingId}-billing`}
                                    queryParams={
                                        `refId=${billingId}`
                                        + `&limit=10`
                                        + `&liveData=true`
                                        + `&partner=dw`
                                        + `&userGroup=trove`
                                    }
                                    searchBox={false}
                                    source={{ url: `/transactions` }}
                                    columns={[
                                        { title: "ACTIVITY", format: formatActivity },
                                        { title: "REFERENCE", format: row => truncateString(row.autoId, 18) },
                                        { title: "DESCRIPTION", key: "comment" },
                                        { title: "USER", format: row => formatUsername(row.userId, row.username, null, row.accountId, "transactions") },
                                        { title: "STATUS", format: row => formatStatus(ucFirst(row.tranStatus)) },
                                        { title: "AMOUNT", format: row => formatAmount(row.currency, row.tranAmount) },
                                        { title: "PARTNER", format: row => ucFirst(row.partner) },
                                        { title: "CREATED AT", format: row => formatDate(row.created) },
                                        { title: "UPDATED AT", format: row => formatDate(row.created) },
                                    ]}
                                    onError={(err) =>
                                        cogoToast.error(errorMessage(err))
                                    }
                                    refreshIcon={true}
                                />
                            </CardBody>
                        </Card>
                    </div>
                </ContentRoute>
                
            </Switch>
        </div>
        <ProcessBillingsModal
            {...processBillingsModal}
            autoId={billingId}
            created={billing?.created}
            onHide={toggleModal("showProcessBillingModal")}
        />

    </>
}